export default __webpack_public_path__ + "static/media/dus_light.9e148c85.png";